function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoldRemediation = function SvgMoldRemediation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 100.8,
    cy: 64.2,
    r: 4.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.2,
    cy: 35.5,
    r: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9,
    cy: 82.3,
    r: 2.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9,
    cy: 55.8,
    r: 2.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8 34c0-.4-3.4-3.9-3.8-3.9-8.6-8-20.1-12.9-32.8-12.9C36.6 17.2 15 38.8 15 65.5s21.7 48.3 48.3 48.3 48.3-21.7 48.3-48.3c-.1-12.1-4.5-23.1-11.8-31.5M63.2 20.2c11.7 0 22.3 4.4 30.3 11.7L29.7 95.8C22.4 87.7 18 77.1 18 65.5c0-25 20.3-45.3 45.2-45.3m0 90.5c-11.1 0-21.2-4-29.1-10.6l63.7-63.7c6.6 7.9 10.6 18 10.6 29.1.1 24.9-20.2 45.2-45.2 45.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6 56.8c1.4 0 2.6-.6 3.5-1.5L49 60.2q-.9 2.4-.9 5.1 0 1.5.3 3l-6.9 3.1c-.6-.6-1.4-1-2.4-1-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4c1.7 0 3.1-1.3 3.3-2.9l6.9-3.1c.3.6.6 1.3 1 1.9l20.3-20.3c-.1-.1-.3-.2-.4-.3l5.3-10.8c.3.1.7.1 1 .1 2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5c0 1.3.5 2.5 1.4 3.4l-5.4 11.1c-1.4-.5-2.9-.7-4.5-.7-1.2 0-2.4.2-3.6.5L57 44c.6-.6.9-1.4.9-2.3 0-1.9-1.5-3.4-3.4-3.4S51 39.7 51 41.6c0 1.7 1.3 3.2 3 3.3l2.4 7.1c-2.5 1.2-4.6 3.1-6.1 5.4l-10.9-4.9c.1-.3.1-.6.1-.9 0-2.8-2.2-5-5-5s-5 2.2-5 5 2.3 5.2 5.1 5.2M91.4 73.6c-1.4 0-2.7.6-3.7 1.6L76.8 70c.5-1.5.8-3.1.8-4.7 0-1.3-.2-2.6-.5-3.9l7.1-2.5c.6.6 1.5 1 2.4 1 1.9 0 3.4-1.5 3.4-3.4s-1.5-3.4-3.4-3.4c-1.7 0-3.1 1.3-3.3 2.9l-4.5 1.6L52 84.4l-2 4.5h-.4c-1.2 0-2.4.5-3.2 1.2l-.6.6c-.7.9-1.2 2-1.2 3.2 0 2.8 2.2 5 5 5s5-2.2 5-5c0-1.5-.7-2.9-1.8-3.8l5-10.9q2.4.9 5.1.9c1.2 0 2.3-.2 3.4-.4l2.6 7.1c-.6.6-.9 1.4-.9 2.3 0 1.9 1.5 3.4 3.4 3.4s3.4-1.5 3.4-3.4c0-1.8-1.3-3.2-3.1-3.3l-2.6-7c2.7-1.3 5-3.3 6.5-5.9l10.9 5.2c0 .2-.1.4-.1.7 0 2.8 2.2 5 5 5s5-2.2 5-5-2.2-5.2-5-5.2",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgMoldRemediation;